import { useExplorer } from "@/context/ExplorerContext";

export default function TrustStrip() {
  const { t } = useExplorer();
  const items = [...t.trust, ...t.trust];
  return (
    <div data-testid="trust-strip" className="relative overflow-hidden border-y border-ink/10 bg-sage-soft py-3.5" aria-label="ضمانات">
      <div className="marquee-track gap-10 text-[0.9rem] font-bold text-ink">
        {items.map((it, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <bdi>{it}</bdi>
            <span aria-hidden className="inline-block h-1.5 w-1.5 rounded-full bg-coral" />
          </span>
        ))}
      </div>
    </div>
  );
}
